// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"38":"b1512ad5","453":"00ddd4f2","781":"af42def2"}[chunkId] + ".chunk.js");